import React, { useState } from "react";

export default function ProductAttributes({
    product,
    setProduct
}) {

    const [tagInput, setTagInput] = useState("");

    const update = (field, value) => {

        setProduct(prev => ({
            ...prev,
            [field]: value
        }));

    };

    const tags = Array.isArray(product.tags)
        ? product.tags
        : product.tags
            ? String(product.tags)
                .split(",")
                .map(x => x.trim())
                .filter(Boolean)
            : [];

    const addTag = () => {

        const value = tagInput.trim();

        if (!value) return;

        if (tags.includes(value)) {

            setTagInput("");

            return;

        }

        update("tags", [
            ...tags,
            value
        ]);

        setTagInput("");

    };

    const removeTag = (tag) => {

        update(
            "tags",
            tags.filter(
                item => item !== tag
            )
        );

    };

    return (

        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: 24
            }}
        >

            <div>

                <h2
                    style={{
                        margin: 0
                    }}
                >
                    Attributes
                </h2>

                <p
                    style={{
                        color: "#666",
                        marginTop: 8
                    }}
                >
                    Organize the product using its category and
                    searchable tags.
                </p>

            </div>

            {/* Category */}

            <div
                style={{
                    background: "#fff",
                    borderRadius: 16,
                    padding: 24,
                    border: "1px solid #e5e7eb"
                }}
            >

                <label
                    style={{
                        fontWeight: 600
                    }}
                >
                    Category
                </label>

                <input
                    value={product.category || ""}
                    onChange={e =>
                        update(
                            "category",
                            e.target.value
                        )
                    }
                    placeholder="Product category"
                    style={inputStyle}
                />

            </div>

            {/* Tags */}

            <div
                style={{
                    background: "#fff",
                    borderRadius: 16,
                    padding: 24,
                    border: "1px solid #e5e7eb"
                }}
            >

                <h3
                    style={{
                        marginTop: 0
                    }}
                >
                    Tags
                </h3>

                <div
                    style={{
                        display: "flex",
                        gap: 10
                    }}
                >

                    <input
                        value={tagInput}
                        onChange={e =>
                            setTagInput(e.target.value)
                        }
                        onKeyDown={e => {

                            if (e.key === "Enter") {

                                e.preventDefault();

                                addTag();

                            }

                        }}
                        placeholder="Add a tag..."
                        style={{
                            ...inputStyle,
                            marginTop: 0,
                            flex: 1
                        }}
                    />

                    <button
                        type="button"
                        onClick={addTag}
                        style={{
                            padding: "0 20px",
                            border: "none",
                            borderRadius: 10,
                            background:
                                "rgb(255,0,204)",
                            color: "#fff",
                            cursor: "pointer",
                            fontWeight: 700
                        }}
                    >
                        Add
                    </button>

                </div>

                {tags.length > 0 && (

                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 10,
                            marginTop: 20
                        }}
                    >

                        {tags.map(tag => (

                            <div
                                key={tag}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    padding:
                                        "8px 12px",
                                    borderRadius: 999,
                                    background:
                                        "#f3f4f6",
                                    border:
                                        "1px solid #e5e7eb"
                                }}
                            >

                                <span>
                                    {tag}
                                </span>

                                <button
                                    type="button"
                                    onClick={() =>
                                        removeTag(tag)
                                    }
                                    style={{
                                        border: "none",
                                        background:
                                            "transparent",
                                        cursor: "pointer",
                                        fontWeight: 700,
                                        color: "#666"
                                    }}
                                >
                                    ×
                                </button>

                            </div>

                        ))}

                    </div>

                )}

            </div>

        </div>

    );

}

const inputStyle = {

    width: "100%",
    boxSizing: "border-box",
    marginTop: 8,
    padding: "12px 14px",
    borderRadius: 10,
    border: "1px solid #d1d5db",
    fontSize: 15

};